import React from "react";
import PhoneInput, { PhoneInputProps } from "react-phone-input-2";
import ar from "react-phone-input-2/lang/ar.json";
import { useLocalize } from "hooks";
import { useTranslation } from "react-i18next";

function FlagComponent(props: PhoneInputProps) {
  const {t} = useTranslation();
  const { currentLanguageCode } = useLocalize();
  
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const countryCode = React.useMemo(() =>  currentLanguageCode === "ar" ?  ar : undefined ,[currentLanguageCode,t])

  return (
    <PhoneInput
      key={currentLanguageCode}
      localization={{...countryCode}}
      buttonClass={props.disabled ? "disabled" : ""}
      containerClass="phone-input"
      {...props}
    />
  );
}

export default FlagComponent;
